module.exports = __webpack_public_path__ + "img/pic_433867.89e76f6f.jpg";